import dropzone from './dropzone'
import table from './table'
import exclusive from './exclusive'
import hereMaps from './here-maps'
import other from './other'
import drivers from './drivers'

export default {
  strict: true,
  namespaced: true,
  state: Object.assign(
    drivers.state,
    dropzone.state,
    table.state,
    exclusive.state,
    hereMaps.state,
    other.state,
  ),
  mutations: Object.assign(
    drivers.mutations,
    dropzone.mutations,
    table.mutations,
    exclusive.mutations,
    hereMaps.mutations,
    other.mutations,
  )
}



// WEBPACK FOOTER //
// ./src/store/runs/index.js